<template>
  <div class="filters-bar">
    <div class="filters-bar__header" :class="{ open: toggleFilters }">
      <h5>{{ 'Filter By:' | t }}</h5>
      <label for="filters-bar-toggle"></label>
      <button
        id="filters-bar-toggle"
        class="filters-bar__header__toggle"
        @click="toggleFilters = !toggleFilters"
      ></button>
    </div>
    <slide-up-down :active="toggleFilters">
      <div
        class="filters-bar__filters"
        :style="`grid-template-columns: repeat(${filtersCount - 1}, calc((100% - 300px) / ${
          filtersCount - 1
        })) auto`"
      >
        <div class="filters-bar__filters__item">
          <label for="filter-date">{{ 'Start date:' | t }}</label>
          <date-picker
            v-model.lazy="filters.startDate"
            :append-to-body="false"
            :input-attr="{ readonly: 'true' }"
            placeholder="mm/dd/yyyy"
            :class="{ empty: !filters.startDate }"
            format="MM/DD/YYYY"
            value-type="YYYY-MM-DD"
          ></date-picker>
        </div>
        <div v-if="!defaultFilters.location.length" class="filters-bar__filters__item">
          <label for="filter-location">{{ 'Location:' | t }}</label>
          <multiselect
            id="filter-location"
            v-model="filters.location"
            :class="{ 'multiselect--filled': filters.location.length }"
            :options="filtersOptions.location"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            select-label=""
            deselect-label=""
            selected-label=""
            :searchable="false"
            placeholder="Show all"
            open-direction="bottom"
            label="filter"
            track-by="id"
          >
            <template slot="selection" slot-scope="{ values }">
              <span v-if="values.length" class="multiselect__single">
                <span class="multi-label">{{ values[0].filter }}</span>
                <span class="multi-count">{{ values.length }}</span>
              </span>
              <select
                ref="input"
                v-model="filters.location"
                name="location-select"
                class="multiselect__native-select"
                multiple
              >
                <option
                  v-for="option in filtersOptions.location"
                  :key="option"
                  name="location-select"
                  :value="option"
                >
                  {{ option.filter }}
                </option>
              </select>
            </template>
          </multiselect>
        </div>
        <div v-if="!defaultFilters.activity.length" class="filters-bar__filters__item">
          <label for="filter-activity">{{ 'Activity:' | t }}</label>
          <multiselect
            id="filter-activity"
            v-model="filters.activity"
            :class="{ 'multiselect--filled': filters.activity.length }"
            :options="filtersOptions.activity"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            select-label=""
            deselect-label=""
            selected-label=""
            :searchable="false"
            placeholder="Show all"
            open-direction="bottom"
            label="filter"
            track-by="id"
          >
            <template slot="selection" slot-scope="{ values }">
              <span v-if="values.length" class="multiselect__single">
                <span class="multi-label">{{ values[0].filter }}</span>
                <span class="multi-count">{{ values.length }}</span>
              </span>
              <select
                ref="input"
                v-model="filters.activity"
                name="activity-select"
                class="multiselect__native-select"
                multiple
              >
                <option
                  v-for="option in filtersOptions.activity"
                  :key="option"
                  name="activity-select"
                  :value="option"
                >
                  {{ option.filter }}
                </option>
              </select>
            </template>
          </multiselect>
        </div>
        <div v-if="!defaultFilters.sport.length" class="filters-bar__filters__item">
          <label for="filter-sport">{{ 'Sport:' | t }}</label>
          <multiselect
            id="filter-sport"
            v-model="filters.sport"
            :class="{ 'multiselect--filled': filters.sport.length }"
            :options="filtersOptions.sport"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            select-label=""
            deselect-label=""
            selected-label=""
            :searchable="false"
            placeholder="Show all"
            open-direction="bottom"
            label="filter"
            track-by="id"
          >
            <template slot="selection" slot-scope="{ values }">
              <span v-if="values.length" class="multiselect__single">
                <span class="multi-label">{{ values[0].filter }}</span>
                <span class="multi-count">{{ values.length }}</span>
              </span>
              <select
                ref="input"
                v-model="filters.sport"
                name="sport-select"
                class="multiselect__native-select"
                multiple
              >
                <option
                  v-for="option in filtersOptions.sport"
                  :key="option"
                  name="sport-select"
                  :value="option"
                >
                  {{ option.filter }}
                </option>
              </select>
            </template>
          </multiselect>
        </div>
        <div v-if="!defaultFilters.gender.length" class="filters-bar__filters__item">
          <label for="filter-gender">{{ 'Gender:' | t }}</label>
          <multiselect
            id="filter-gender"
            v-model="filters.gender"
            :class="{ 'multiselect--filled': filters.gender.length }"
            :options="filtersOptions.gender"
            :multiple="true"
            :clear-on-select="false"
            :close-on-select="false"
            :preserve-search="true"
            select-label=""
            deselect-label=""
            selected-label=""
            :searchable="false"
            placeholder="Show all"
            open-direction="bottom"
            label="filter"
            track-by="id"
          >
            <template slot="selection" slot-scope="{ values }">
              <span v-if="values.length" class="multiselect__single">
                <span class="multi-label">{{ values[0].filter }}</span>
                <span class="multi-count">{{ values.length }}</span>
              </span>
              <select
                ref="input"
                v-model="filters.gender"
                name="gender-select"
                class="multiselect__native-select"
                multiple
              >
                <option
                  v-for="option in filtersOptions.gender"
                  :key="option"
                  name="gender-select"
                  :value="option"
                >
                  {{ option.filter }}
                </option>
              </select>
            </template>
          </multiselect>
        </div>
        <div v-if="!defaultFilters.age.length" class="filters-bar__filters__item">
          <label for="filter-age">{{ 'Age:' | t }}</label>
          <multiselect
            id="filter-age"
            v-model="filters.age"
            :class="{ 'multiselect--filled': filters.age.length }"
            :options="filtersOptions.age"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            select-label=""
            deselect-label=""
            selected-label=""
            :searchable="false"
            placeholder="Show all"
            open-direction="bottom"
            label="filter"
            track-by="id"
          >
            <template slot="selection" slot-scope="{ values }">
              <span v-if="values.length" class="multiselect__single">
                <span class="multi-label">{{ values[0].filter }}</span>
                <span class="multi-count">{{ values.length }}</span>
              </span>
              <select
                ref="input"
                v-model="filters.age"
                name="age-select"
                class="multiselect__native-select"
                multiple
              >
                <option
                  v-for="option in filtersOptions.age"
                  :key="option"
                  name="age-select"
                  :value="option"
                >
                  {{ option.filter }}
                </option>
              </select>
            </template>
          </multiselect>
        </div>
        <div class="filters-bar__filters__item filters-bar__filters__item--search">
          <label for="filter-search">{{ 'Search:' | t }}</label>
          <div class="search-wrapper">
            <input
              id="filter-search"
              v-model.lazy="filters.search"
              type="text"
              :placeholder="'Keyword(s)' | t"
            />
          </div>
        </div>
        <div class="filters-bar__filters__clear">
          <button @click="FiltersResetDefault">{{ 'Clear Filters' | t }}</button>
        </div>
      </div>
    </slide-up-down>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'
import DatePicker from 'vue2-datepicker'

export default {
  components: {
    SlideUpDown,
    DatePicker
  },
  props: {
    filtersOptions: {
      type: Object,
      default: null
    },
    initialFilters: {
      type: Object,
      default: null
    },
    defaultFilters: {
      type: Object,
      default: null
    },
    page: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      toggleFilters: true,
      breakPointLg: parseInt(getComputedStyle(document.body).getPropertyValue('--breakpoint-lg')),
      windowWidth: window.innerWidth,
      initialQueryParsed: false,
      filters: JSON.parse(JSON.stringify(this.initialFilters))
    }
  },
  computed: {
    filtersCount() {
      const items = Object.values(this.defaultFilters).reduce(
        (acc, item) => (!item.length ? (acc += 1) : acc),
        0
      )
      return this.defaultFilters.category.length ? items : items - 1
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.$emit('filters-changed', this.filters)
      }
    },
    'filters.search'(searchQuery) {
      if (searchQuery)
        window.dataLayer.push({
          event: 'sns-activenet-widget',
          'sns-widget-category': 'spookynook-activenet-calendar',
          'sns-widget-action': 'search',
          'sns-widget-label': searchQuery
        })
    }
  },
  beforeMount() {
    if (this.windowWidth < this.breakPointLg) this.toggleFilters = false
  },
  mounted() {
    window.addEventListener('resize', () => {
      // Open filters on lg viewport.
      if (this.windowWidth > this.breakPointLg) this.toggleFilters = true
      // Update windowWidth on resize (for filters bar collapse).
      this.windowWidth = window.innerWidth
    })
  },
  methods: {
    FiltersResetDefault() {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters))
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-bar {
  background-color: $color-gray;
  border-radius: 5px;
  padding: 9px 15px 0;
  position: relative;

  @include media-breakpoint-up(lg) {
    padding: 12px 20px 0;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 7px;
    border-bottom: 2px solid transparent;
    @include anim(border-bottom);
    position: relative;

    &.open {
      border-bottom: 2px solid $color-green;

      @include media-breakpoint-up(lg) {
        border: none;
      }
    }

    label {
      position: absolute;
      top: -9px;
      bottom: 0;
      left: -15px;
      right: -15px;
      margin: 0;
      cursor: pointer;

      @include media-breakpoint-up(lg) {
        display: none;
      }
    }

    h5 {
      margin-bottom: 0;
    }

    &__toggle {
      position: relative;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0;
      background: transparent;

      @include media-breakpoint-up(lg) {
        display: none;
      }

      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        height: 2px;
        width: 16px;
        background: $color-green;
        @include anim(transform);
      }

      &:after {
        transform: translateY(-50%) rotate(-90deg);

        .open & {
          transform: translateY(-50%);
        }
      }
    }
  }

  &__filters {
    padding: 20px 0 24px;

    @include media-breakpoint-up(lg) {
      display: grid;
      grid-template-columns: repeat(6, calc((100% - 300px) / 6)) 1fr;
      column-gap: 10px;
    }

    &__item {
      margin-bottom: 20px;

      @include media-breakpoint-up(lg) {
        flex: 1;
        margin-bottom: 0;
      }

      &--search {
        @include media-breakpoint-up(lg) {
          min-width: 240px;
          margin-right: 0;
        }

        input {
          padding-right: 32px !important;
        }
      }

      label {
        font-size: rem(18);
        line-height: rem(27);
        font-family: $font-secondary;
        margin-bottom: 10px;
        display: block;
      }

      input,
      select {
        background: transparent;
        box-shadow: 0 1px 0 $box-shadow;
        border: 1px solid $color-border;
        border-radius: 5px;
        width: 100%;
        padding: 8px 10px;
        appearance: none;
        font-size: rem(14) !important;
        line-height: rem(19) !important;
        box-sizing: border-box;
      }

      input[type='date'] {
        padding: 7px 10px;
        height: 37px;

        &::-webkit-calendar-picker-indicator {
          opacity: 0;
          height: 100%;
          position: absolute;
          width: 30px;
          right: 0;
          cursor: pointer;
        }
      }

      .search-wrapper,
      .select-wrapper {
        position: relative;

        select {
          padding-right: 30px;
        }

        &:before {
          content: '\e313';
          font-family: $font-material;
          color: $color-green;
          font-size: 18px;
          cursor: pointer;
          position: absolute;
          width: 30px;
          right: 0;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          pointer-events: none;
        }
      }

      .search-wrapper {
        &:before {
          content: '\e8b6';
          font-size: 24px;
          width: 40px;
        }
      }
    }

    &__clear {
      button {
        box-shadow: 0 1px 0 $box-shadow;
        border: 2px solid $color-green;
        border-radius: 5px;
        font-size: rem(16);
        color: $color-green;
        width: 100%;
        padding: 7px 0;
        text-align: center;
        text-transform: uppercase;
        font-family: $font-secondary;
        line-height: rem(19);
        margin-top: 5px;
        background: transparent;
        cursor: pointer;

        @include media-breakpoint-up(lg) {
          border: none;
          position: absolute;
          right: 0;
          top: 0;
          padding: 16px 20px;
          width: auto;
          font-size: rem(14);
          line-height: rem(17);
          margin: 0;
        }
      }
    }
  }
}
</style>
